import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingSecurity6 = props => (
    <section id="outsourcing-security-section6" className="black-bg my pt-5">
        <div className='white-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingSecurity:section-6.title')}</h2>
            <p className='mb-5'><Trans i18nKey="services:outsourcingSecurity:section-6.txt" components={{ br: <br /> }} /></p>
            {[1, 2, 3, 4, 5, 6].map(item => (
                <div key={item} className='mb-4'>
                    <h3 className='h6 fw-600 light-orange'>{props.t('services:outsourcingSecurity:section-6.' + item + '.title')}</h3>
                    <p><Trans i18nKey={'services:outsourcingSecurity:section-6.' + item + '.text'} components={{ br: <br /> }} /></p>
                </div>
            ))}
        </Container>
    </section>
);

export default OutsourcingSecurity6;
